// extracted by mini-css-extract-plugin
export var navItem = "SectionNavigation-module--navItem--Ar6mb";
export var wrapper = "SectionNavigation-module--wrapper--eHLVg";